import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        alerts: [],
        alertPanelOpen: false,
        focus: {
            trigger: false,
            alerts: false,
        },
        initial: {
            hasClickedEscape: false,
            hasClickedScreen: false,
            hasClickedTrigger: false,
            hasOpenedPill: false,
            hasRunOutTimer: false,
            hasScrolled: false,
        },
        initialModeComplete: false,
        warningActive: true,
    },

    mutations: {
        SET_ALERTS (state, payload) {
            state.alerts = [...state.alerts, ...payload]
        },

        SET_ALERT_PANEL_OPEN (state, lock) {
            state.alertPanelOpen = true
            if (lock) {
                document.body.classList.add('-lockScroll')
            }
        },

        SET_ALERT_PANEL_CLOSED (state, lock) {
            state.alertPanelOpen = false
            document.body.classList.remove('-lockScroll')
        },

        TOGGLE_ALERT_PANEL (state, lock = true) {
            state.alertPanelOpen
                ? this.commit('SET_ALERT_PANEL_CLOSED', lock)
                : this.commit('SET_ALERT_PANEL_OPEN', lock)
        },

        SET_INITIAL_MODE_COMPLETE (state, payload) {
            state.initialModeComplete = true
        },

        UPDATE_INITIAL (state, payload) {
            Object.keys(payload).forEach((key) => {
                state.initial[key] = payload[key]
            })
        },

        REMOVE_WARNING (state, payload) {
            state.warningActive = false
        },

        SET_TRIGGER_FOCUS (state, payload) {
            state.focus.trigger = payload
        },

        SET_ALERTS_FOCUS (state, payload) {
            state.focus.alerts = payload
        },
    },
})
